/**
 * Results Templates
 * Template functions for product filters and search results
 */

;(function (templates) {
  const translations = window.theme.tagalys.results.translations

  /* ==========================================================================
     SVG Icons
     ========================================================================== */

  templates.chevronDownIcon = function () {
    return `
      <svg viewBox="0 0 14 8" fill="none" stroke="currentColor" xmlns="http://www.w3.org/2000/svg">
        <path d="M13 1L7 7L1 0.999998" />
      </svg>
    `
  }

  templates.checkmarkIcon = function () {
    return `
      <svg width="10" height="7" viewBox="0 0 10 7" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_353_110)">
          <path d="M1.36377 3.18191L2.57589 4.31827L3.78801 5.45463L8.6365 0.90918" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"></path>
        </g>
        <defs>
          <clipPath id="clip0_353_110">
            <rect width="10" height="6.36364" fill="#fff"></rect>
          </clipPath>
        </defs>
      </svg>
    `
  }

  templates.closeIcon = function () {
    return `
      <svg viewBox="0 0 17 17" fill="none" stroke="currentColor" xmlns="http://www.w3.org/2000/svg">
        <path d="M1 16L16 1" />
        <path d="M16 16L1 1" />
      </svg>
    `
  }

  templates.closeIconLarge = function () {
    return `
      <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-close" viewBox="0 0 14 14" width="20" height="20" aria-hidden="true" focusable="false" role="presentation" fill="none">
        <path d="M.693 1.4l11.749 11.749.707-.707L1.4.693z" fill="currentColor"></path>
        <path d="M12.442.693L.693 12.442l.707.707L13.149 1.4z" fill="currentColor"></path>
      </svg>
    `
  }

  /* ==========================================================================
     Facet Item Templates
     ========================================================================== */

  templates.facetWrapper = function (facet, index) {
    if (facet.type === 'range') {
      return `
        <form data-product-filters-el="form" name="${facet.id}" data-form-type="price">
          <price-range
            class="prc-Range"
            data-index="${index}"
          >
            <div class="prc-Range_Field">
              <div class="prc-Range_InputContainer">
                <span class="prc-Range_Symbol fz-16_1375">
                  ${window.theme.currencySymbol}
                </span>

                <input
                  class="prc-Range_Input fz-16_1375"
                  name="${facet.id}"
                  id="${facet.id}-lte"
                  value="${facet.selected_min}"
                  type="number"
                  placeholder="0"
                  min="0"
                  max="${facet.max}"
                  data-price-range-el="min"
                />
              </div>

              <label
                class="prc-Range_Label fz-14_171"
                for="${facet.id}-lte"
              >
                ${window.theme.strings.plp.price_range.min}
              </label>
            </div>

            <div class="prc-Range_Field">
              <div class="prc-Range_InputContainer">
                <span class="prc-Range_Symbol fz-16_1375">
                  ${window.theme.currencySymbol}
                </span>

                <input
                  class="prc-Range_Input fz-16_1375"
                  name="${facet.id}"
                  id="${facet.id}-gte"
                  value="${facet.selected_max}"
                  type="number"
                  min="0"
                  placeholder="${facet.max}"
                  max="${facet.max}"
                  data-price-range-el="max"
                />
              </div>

              <label
                class="prc-Range_Label fz-14_171"
                for="${facet.id}-gte"
              >
                ${window.theme.strings.plp.price_range.max}
              </label>
            </div>
          </price-range>
        </form>
      `
    }

    return `
      <form data-product-filters-el="form" name="${
        facet.id
      }" data-form-type="filter">
        <ul
          class="clc-Facet_Items"
          data-index="${index}"
        >
          ${facet.items
            .map(value => {
              return templates.facetCheckboxItem(facet, value)
            })
            .join('')}
        </ul>
      </form>`
  }

  templates.facetCheckboxItem = function (facet, value) {
    return `
      <li class="clc-Facet_Item">
        <div class="clc-Facet_Option fz-14_171" data-filter-search-el="facet" data-facet="${
          value.id
        }">
          <input
            class="clc-Facet_OptionCheckbox util-ScreenReaderOnly"
            id="${facet.id}-${value.id}"
            name="${facet.label}"
            value="${value.id}"
            type="checkbox"
            ${value.selected ? 'checked' : ''}
          >

          <span
            class="clc-Facet_OptionCheckboxIcon ${
              window.theme.tagalys.swatches[value.label]
                ? 'clc-Facet_OptionCheckboxIcon-colour'
                : ''
            }"
            ${
              window.theme.tagalys.swatches[value.label]
                ? `style="--OptionCheckbox_Background: ${
                    window.theme.tagalys.swatches[value.label]
                  };"`
                : ''
            }"
          ></span>

          <label
            class="clc-Facet_OptionLabel"
            for="${facet.id}-${value.id}"
          >
            ${value.label} (${value.count})
          </label>
        </div>
      </li>
    `
  }

  /* ==========================================================================
     Filter Templates
     ========================================================================== */

  templates.filterDetails = function (facet, index) {
    const openFilters = window.theme.tagalys.openFacets || []
    const isOpen = openFilters.includes(facet.id)
    const disabledFacets = window.theme.tagalys.disabledFacets || []
    const isDisabled = disabledFacets.includes(facet.label)

    if (isDisabled) return ``

    return `
      <accordion-drawer
        class="clc-Facet"
        data-accordion-group-el="drawer"
        data-accordion-id="facet-${index}"
        data-id="${facet.id}"
        data-group-id="facets"
        ${isOpen ? 'open' : ''}
      >
        <h2 class="clc-Facet_Title">
          <button
            class="clc-Facet_Toggle fz-13_162"
            data-accordion-drawer-el="toggle"
            data-accordion-id="facet-${index}"
            data-index="${index}"
            type="button"
          >
            ${facet.label}

            <span class="clc-Facet_ToggleIcon">
              ${templates.chevronDownIcon()}
            </span>
          </button>
        </h2>

        <div class="clc-Facet_Panel" data-accordion-drawer-el="panel">
          ${templates.facetWrapper(facet, index)}
        </div>
      </accordion-drawer>
    `
  }

  templates.activeFilterPill = function (facet, value) {
    return `
      <li class="clc-ActiveFacets_Item">
        <button class="clc-ActiveFacets_FacetLink fz-14_171" data-product-filters-el="remove-facet" data-facet="${
          value.id
        }" data-facet-field="${facet.id}">
          ${value.label}

          <span class="clc-ActiveFacets_FacetLinkIcon">
            ${templates.closeIcon()}
          </span>
        </button>
      </li>
    `
  }

  templates.activeFilterPricePill = function (facet) {
    return `
      <li class="clc-ActiveFacets_Item">
        <button class="clc-ActiveFacets_FacetLink fz-14_171" data-product-filters-el="remove-facet" data-facet-field="${
          facet.id
        }">
          ${window.BAO.Utils.formatMoney(facet.selected_min * 100)}
          -
          ${window.BAO.Utils.formatMoney(facet.selected_max * 100)}

          <span class="clc-ActiveFacets_FacetLinkIcon">
            ${templates.closeIcon()}
          </span>
        </button>
      </li>
    `
  }

  templates.clearAllButton = function () {
    return `
      <li class="product-filters-desktop__listitem">
        <button class="product-filters__clear-all" type="button" data-product-filters-el="clear-all">
          ${translations.clearAll}
          ${templates.closeIconLarge()}
        </button>
      </li>
    `
  }
})(window.theme.tagalys.templates)
